import { render, staticRenderFns } from "./HospitalLayout.vue?vue&type=template&id=2e463e15"
import script from "./HospitalLayout.vue?vue&type=script&lang=ts"
export * from "./HospitalLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports